import PropTypes from "prop-types"

const ImportErrorShape = PropTypes.shape({
  index: PropTypes.number,
  reason: PropTypes.string,
})

export default ImportErrorShape
